import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Roles } from '../../core/security/model/roles';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: 'edit-user-modal.html',
  styleUrls: ['./edit-user-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditUserModalComponent implements OnInit {
  roles = Object.keys(Roles).map(value => value);
  user: any;
  formGroup: FormGroup;

  constructor(private dialogRef: MatDialogRef<EditUserModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private cd: ChangeDetectorRef) {
    this.prepareFormGroup();
    this.cd.markForCheck();
  }

  ngOnInit(): void {
    if (this.data) {
      this.user = this.data.user;
      this.formGroup.patchValue(this.user);
    }
  }

  dismiss(data: any) {
    if (data && data.delete) {
      this.dialogRef.close(data);
    } else if (data) {
      this.dialogRef.close(this.formGroup.getRawValue());
    } else {
      this.dialogRef.close(null);
    }
  }

  prepareFormGroup(): void {
    this.formGroup = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(Utils.emailValidator)]),
      role: new FormControl('', Validators.required)
    });
  }

}
